/**
 * StyleX styles for admin foods feature.
 */

import * as stylex from "@stylexjs/stylex";

export const styles = stylex.create({
  tagContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 4,
    alignItems: "center",
  },
  tag: {
    fontSize: 11,
  },
  macroCell: {
    fontFamily: "monospace",
    fontSize: 13,
  },
  wideModal: {
    maxWidth: 560,
  },
  modalBody: {
    marginBottom: 16,
  },
  flexWrap: {
    flexWrap: "wrap",
  },
  detailGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 16,
  },
  detailSection: {
    marginBottom: 16,
  },
  detailLabel: {
    fontSize: 12,
    marginBottom: 4,
  },
  detailValue: {
    fontSize: 14,
  },
  macroGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 12,
  },
  macroItem: {
    textAlign: "center",
    paddingBlock: 8,
    paddingInline: 12,
    borderRadius: 8,
    backgroundColor: "rgba(255,255,255,0.05)",
  },
  macroValue: {
    fontSize: 20,
    fontWeight: 600,
  },
  macroLabel: {
    fontSize: 11,
    marginTop: 2,
  },
});
